import $ from "jquery";
// import videojs from "video.js";

const video = () => {
  const el = {
    container: ".VideoSection__Wrapper",
    videoEl: ".VideoSection__Wrapper #yt-video",
  };
  if ($(el.container).length === 0) return;

  $(() => {
    // const options = {
    //   controls: true, // Show video controls
    //   autoplay: false, // Automatically play the video on load
    //   preload: "auto", // Preload the video metadata
    //   bigPlayButton: false, // Hide the big play button
    //   // Add any other options you need
    // };

    // const player = videojs("single-video", options);

    // Load the IFrame Player API code asynchronously.
    let tag = document.createElement("script");
    tag.src = "https://www.youtube.com/player_api";
    let firstScriptTag = $("script").first();
    firstScriptTag.parent().prepend(tag);

    const linkID = $(el.videoEl).data("link-id");
    // Replace the 'ytplayer' element with an <iframe> and
    // YouTube player after the API code downloads.
    function initializePlayer() {
      // eslint-disable-next-line no-undef
      new YT.Player("yt-video", {
        height: "auto", // Set the desired height
        width: "100%", // Set the desired width
        videoId: linkID,
        playerVars: {
          autoplay: 1, // Autoplay the video
          mute: 1,
          controls: 0, // Hide player controls
          loop: 1, // Loop the video
          playlist: linkID, // Ensure the video loops
          showinfo: 0, // Hide video information
        },
        events: {
          onReady: onPlayerReady,
        },
      });
    }
    window.onYouTubeIframeAPIReady = initializePlayer;

    function onPlayerReady() {
      // You can add custom actions here once the player is ready
    }
  });
};

try {
  video();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
